import { render } from "./FormatView.vue?vue&type=template&id=6898659e&scoped=true"
import script from "@/assets/js/components/formate.js?vue&type=script&lang=js&external"
export * from "@/assets/js/components/formate.js?vue&type=script&lang=js&external"

import "@/assets/css/components/formate.css?vue&type=style&index=0&id=6898659e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6898659e"]])

export default __exports__